// @flow strict

import * as React from 'react';
import classNames from '@ta/common.classnames';
import ManagedTextInput, { type Props as ManagedTextInputProps } from './ManagedTextInput';
import styles from './TextInput.css';

/**
 * This is a version of ManagedTextInput that uses standard TA styling
 */
const TextInput = (props: ManagedTextInputProps) => {
  const className = classNames(styles.inputElement, props.className);
  const allProps = { ...props, className };
  return <ManagedTextInput {...allProps} />;
};

export default TextInput;
